// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39JRY","option":"styles_option__24Rez","active":"styles_active__GV3_q"};